export default __webpack_public_path__ + "static/media/payment.a896a1bd.svg";